export default {
    namespaced: true,
    state: {
        titles: null
    },
    getters: {
        titles: (state) => {
            return state.titles;
        }
    },
    actions: {

    },
    mutations: {
        titles (state, titles) {
            state.titles = titles;
        }
    }
}